import React from "react";

const containerCls = "min-h-screen bg-white text-slate-800";
const wrapCls = "max-w-3xl mx-auto px-6 py-12";
const h1Cls = "text-3xl sm:text-4xl font-bold text-slate-900 mb-2";
const effectiveCls = "text-sm text-slate-500 mb-8";
const h2Cls = "text-xl font-semibold text-slate-900 mt-8 mb-3";
const pCls = "text-base leading-relaxed mb-4";
const ulCls = "list-disc pl-6 space-y-1 mb-4 text-base leading-relaxed";
const footerCls = "mt-16 pt-6 border-t border-slate-200 text-sm text-slate-500";

export default function DataDeletionPolicy() {
  return (
    <div className={containerCls} data-testid="data-deletion-policy-page">
      <div className={wrapCls}>
        <h1 className={h1Cls}>PrepHacker-RN Data Deletion Policy</h1>
        <p className={effectiveCls}>Effective Date: July 22, 2026</p>

        <h2 className={h2Cls}>1. Requesting Data Deletion</h2>
        <p className={pCls}>Users may request deletion of their account by contacting:</p>
        <p className={pCls}>
          <a href="mailto:hello@prephacker.com" className="text-orange-600 hover:underline">
            hello@prephacker.com
          </a>
        </p>
        <p className={pCls}>or through account settings if available.</p>

        <h2 className={h2Cls}>2. Information Deleted</h2>
        <p className={pCls}>Upon approval, we may delete:</p>
        <ul className={ulCls}>
          <li>Profile information</li>
          <li>Contact information</li>
          <li>Learning history</li>
          <li>AI conversation history</li>
          <li>WhatsApp conversation history</li>
          <li>Email conversation history</li>
          <li>Analytics associated with the account</li>
        </ul>

        <h2 className={h2Cls}>3. Information We May Retain</h2>
        <p className={pCls}>Certain information may be retained where required for:</p>
        <ul className={ulCls}>
          <li>Legal compliance</li>
          <li>Fraud prevention</li>
          <li>Accounting</li>
          <li>Security investigations</li>
        </ul>

        <h2 className={h2Cls}>4. Soft Deletion</h2>
        <p className={pCls}>
          PrepHacker-RN may initially mark an account as deleted using internal administrative controls
          before permanent deletion from backups and production systems.
        </p>

        <h2 className={h2Cls}>5. Processing Time</h2>
        <p className={pCls}>
          We aim to process verified deletion requests within 30 days, subject to legal and operational
          requirements.
        </p>

        <h2 className={h2Cls}>6. Contact</h2>
        <p className={pCls}>For deletion requests or privacy concerns, contact:</p>
        <p className={pCls}>
          Email:{" "}
          <a href="mailto:hello@prephacker.com" className="text-orange-600 hover:underline">
            hello@prephacker.com
          </a>
        </p>

        <div className={footerCls}>
          © PrepHacker-RN · A product of Touch Universe Creative Services Pvt. Ltd. · Contact:{" "}
          <a href="mailto:hello@prephacker.com" className="text-orange-600 hover:underline">
            hello@prephacker.com
          </a>
        </div>
      </div>
    </div>
  );
}
